// Core button components re-exported from pattern library
export {
  Button,
  ButtonProps,
  SolidButton,
  ErrorButton,
  CancelButton,
  WarningButton,
  ButtonGroup,
  ButtonSpinner,
  IconButton,
  IconButtonProps,
  baseButtonStyle,
  solidButtonStyle,
  invertedButtonStyle,
} from 'equa-patternlib'

// Import shared styles for extending local components
import { css, ThemeProps } from 'styled-components'
import { colors, fontSizes, Theme, Themes } from '@src/styles/theme'
import styled from 'styled-components'
import { PathLink } from '@components/navigation/path-link'
import { Link } from 'react-router-dom'
import { baseButtonStyle, solidButtonStyle, invertedButtonStyle } from 'equa-patternlib'

export const transparentButtonStyle = css`
  color: ${props => props.theme.listIcon} !important;
  background-color: transparent;
  &:disabled {
    opacity: 0.6;
  }
`

// Navigation-specific button variants (equa-web specific)
export const InputButton = styled.div<any>`
  ${baseButtonStyle}
  ${solidButtonStyle}
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  padding: 12px 32px;
  background: ${props => props.hasErrors && colors.errorRed};
  &:hover {
    background-color: ${props => props.hasErrors && props.theme.button.error.hover};
  }
`

export const PathLinkButton = styled<any>(PathLink)`
  ${baseButtonStyle}
  ${solidButtonStyle}
`

export const LoginSignButton = styled.button<ThemeProps<Theme>>`
  ${baseButtonStyle}
  ${solidButtonStyle}
`

export const PathLinkInvertedButton = styled<any>(PathLink)`
  ${baseButtonStyle}
  ${invertedButtonStyle}
`

export const LinkButton = styled(Link)`
  ${baseButtonStyle}
  ${solidButtonStyle}
`

export const PathLinkButtonInverted = styled<any>(PathLink)`
  ${baseButtonStyle}
  ${invertedButtonStyle}
`

export const SubmitButton = styled.button<any>`
  ${baseButtonStyle}
  ${solidButtonStyle}
`

export const InvertedButton = styled.div<any>`
  ${baseButtonStyle}
  ${invertedButtonStyle}
`

export const SkipLinkButton = styled<any>(PathLink)`
  ${baseButtonStyle}
  ${transparentButtonStyle}
  &:hover {
    text-decoration: underline;
  }
`

export const ClearButton = styled.button<any>`
  ${baseButtonStyle}
  ${transparentButtonStyle}
  border: none;
  &:hover {
    background: ${props => props.theme.button.cancel.hover};
    color: ${props => props.theme.selected === Themes.LIGHT && colors.white} !important;
  }
  &:disabled  {
    color: #BFBFBF !important;
    background: transparent;
  }
`

export const InvertedWarningButton = styled.button<any>`
  ${baseButtonStyle}
  border: 1px solid ${props => props.theme.button.warning.default};
  color: ${props => props.theme.button.warning.default} !important;
  background-color: ${props => props.submitting ?
    props.theme.button.warningI.submitting
    :
    props.theme.button.warningI.default} !important;
  height: 40px;
  &:hover {
    border: 1px solid ${props => props.theme.button.warning.hover};
    background: ${props => props.theme.button.warningI.hover};
    color: ${props => props.theme.button.warning.hover} !important;
  }
  &:disabled  {
    color: #BFBFBF !important;
    border: 1px solid #BFBFBF !important;
    background: ${props => props.theme.button.warningI.disabled};
    opacity: 0.8;
  }
`

export const SlimButton = styled.button<any>`
  ${baseButtonStyle}
  color: ${props => props.theme.listIcon} !important;
  height: 40px;
  border: none !important;
  background: ${props => props.submitting ?
    props.theme.button.cancel.submitting
    :
    props.theme.button.cancel.default};
  padding: 12px 32px;
  margin-bottom: 16px;
  margin-left: 0 !important;
  width: 100%;
  height: 32px;
  background: ${props => props.theme.selected === Themes.LIGHT && '#92AABA'};
  color: ${colors.white} !important;
  svg {
    margin-right: 8px;
    path {
      fill: ${colors.white};
    }
  }
  &:hover {
    background: ${props => props.theme.button.cancel.hover};
    color: ${props => props.theme.selected === Themes.LIGHT && colors.white} !important;
  }
  &:disabled  {
    color: #BFBFBF !important;
    background: ${props => props.theme.button.cancel.disabled};
  }
`
